import { REQUEST_URL } from "../constants";
import { PaginationQueryModel } from "../models";
import { RequestUtil } from "../utils";

export const BlogService = {
  filterBlogs,
  filterCategories,
  getBlogById,
  createBlog,
  updateBlog,
  deleteBlog,
  getAllAuthors,
  getAllLabels,
  createCategory,
  updateCategory,
  deleteCategory,
  getCategoryByCode,
  createLabel,
};

function filterBlogs(
  query: PaginationQueryModel & {
    searchValue?: string;
    parentId?: string;
    urlCategory?: string;
    languageId?: string;
  } = {}
) {
  const url = REQUEST_URL.FILTER_BLOG;
  const queryData: any = { ...query };

  return RequestUtil.get({ url, query: queryData });
}

function filterCategories(
  query: PaginationQueryModel & {
    languageId?: string;
    type?: string;
  } = {}
) {
  const queryData: any = { ...query };
  const url = REQUEST_URL.FILTER_BLOG_CATEGORY;

  return RequestUtil.get({ url, query: queryData });
}

function getBlogById(code: string) {
  const url = REQUEST_URL.BLOG_DETAIL.replace("{CODE}", code);

  return RequestUtil.get({ url });
}

function createBlog(data) {
  const url = REQUEST_URL.BLOG;

  return RequestUtil.post({ url, data });
}

function updateBlog(code: string, data) {
  const url = REQUEST_URL.BLOG_DETAIL.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

function deleteBlog(code: string) {
  const url = REQUEST_URL.BLOG_DETAIL.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}

function getAllAuthors() {
  const url = REQUEST_URL.GET_ALL_AUTHORS;

  return RequestUtil.get({ url });
}

function getAllLabels() {
  const url = REQUEST_URL.LABEL;

  return RequestUtil.get({ url });
}

function createCategory(data , queryData: {
  status?: string;
} = {}) {
  const url = REQUEST_URL.BLOG_CATEGORY;

  return RequestUtil.post({ url, data , query: {...queryData}});
}

function updateCategory(code: string, data, queryData: {
  status?: string;
} = {}) {
  const url = REQUEST_URL.BLOG_CATEGORY_DETAIL.replace(
    "{CODE}",
    code
  );

  return RequestUtil.put({ url, data, query: {...queryData}});
}

function deleteCategory(code: string) {
  const url = REQUEST_URL.BLOG_CATEGORY_DETAIL.replace(
    "{CODE}",
    code
  );

  return RequestUtil.delete({ url });
}

function getCategoryByCode(code: string) {
  const url = REQUEST_URL.BLOG_CATEGORY_DETAIL.replace("{CODE}", code);

  return RequestUtil.get({ url });
}

function createLabel(input: { name: string }) {
  const url = REQUEST_URL.LABEL;

  return RequestUtil.post({ url, data: input });
}